import React, { useState, useRef, useCallback } from 'react';
// import PropTypes from 'prop-types';

import useOutsideClick from 'utils/hooks/useOutsideClick';

import { FiMoreVertical } from 'react-icons/fi';

import { Menu, MenuList, Item } from './styles';
import Tooltip from 'components/Tooltip';

interface Props {
  id: string;
  actions: Action[];
  disabled: boolean;
  handleClick: (action: Action) => void;
  isDropUp?: boolean;
  round?: boolean;
  fill?: boolean;
  color?: string;
  size?: string;
}
export interface Action {
  disabled?: boolean;
  value: number;
  icon?: JSX.Element;
  label: string;
  tooltip?: string;
  href?: string;
}

// export default function DropDownMenu({
//   actions,
//   handleClick,
//   disabled = false,
//   isDropUp = false,
//   round = true,
//   fill = true,
//   color = 'font',
//   size = 'sm',
//   ...rest
// }: Props) {
const DropDownMenu: React.FC<Props> = ({
  actions,
  handleClick,
  disabled = false,
  isDropUp = false,
  round = true,
  fill = true,
  color = 'font',
  size = 'sm',
  ...rest
}: Props) => {
  const [visible, setVisible] = useState(false);
  const menuListRef = useRef(null);

  useOutsideClick(menuListRef, () => {
    if (visible) setVisible(false);
  });

  const handleToggleVisible = useCallback(e => {
    e.stopPropagation();
    setVisible(prevState => !prevState);
  }, []);

  return (
    <Menu
      onClick={e => handleToggleVisible(e)}
      disabled={disabled}
      color={color}
      $round={round}
      $fill={fill}
      size={size}
      {...rest}
    >
      <FiMoreVertical />
      <MenuList ref={menuListRef} $visible={visible} $isDropUp={isDropUp}>
        {actions.map((item, key) => {
          const itemId = `${rest.id}_action_${key}`;
          const content = (
            <>
              {item.icon}
              <span>{item.label}</span>
              {item.tooltip && (
                <Tooltip target={itemId} position="left">
                  {item.tooltip}
                </Tooltip>
              )}
            </>
          );

          return (
            <Item disabled={item.disabled || false}>
              {item.href && !item.disabled ? (
                <a href={item.href} id={itemId}>
                  {content}
                </a>
              ) : (
                <div onClick={() => handleClick(item)} id={itemId}>
                  {content}
                </div>
              )}
            </Item>
          );
        })}
      </MenuList>
    </Menu>
  );
};

export default DropDownMenu;

// DropDownMenu.defaultProps = {
//   color: 'font',
//   fill: 'true',
//   round: 'true',
//   disabled: false,
//   isDropUp: false,
// };

// DropDownMenu.propTypes = {
//   handleClick: PropTypes.func.isRequired,
//   disabled: PropTypes.bool,
//   isDropUp: PropTypes.bool,
//   actions: PropTypes.arrayOf(
//     PropTypes.shape({
//       value: PropTypes.number,
//       label: PropTypes.string,
//       icon: PropTypes.node,
//       disabled: PropTypes.bool,
//     }),
//   ).isRequired,
// };
